import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { AuthBootstrapSkeleton } from '@/shared/components/skeletons'

export function AuthBootstrapSpinner() {
  return <AuthBootstrapSkeleton />
}

/** Shared redirect when the user is not authenticated (me failed or no session). */
export function AuthRedirectWhenUnauthenticated({
  mustSetPassword,
}: {
  readonly mustSetPassword: boolean
}) {
  const location = useLocation()

  if (mustSetPassword) {
    if (location.pathname === '/set-password') {
      return <Outlet />
    }
    return <Navigate to="/set-password" replace />
  }

  return <Navigate to="/login" state={{ from: location }} replace />
}
